<div class="p-b-10">
    <icon-label [icon]="'chevron2-left'"
                [iconLink]="link"
                [offset]="4"
                [fullWidth]="client.sizeId < 2"
                [textClass]="'h3'">
        <ng-content></ng-content>
    </icon-label>
</div>